import { render, staticRenderFns } from "./PcsAuth.vue?vue&type=template&id=e40535c2&scoped=true"
import script from "./PcsAuth.vue?vue&type=script&lang=js"
export * from "./PcsAuth.vue?vue&type=script&lang=js"
import style0 from "./PcsAuth.vue?vue&type=style&index=0&id=e40535c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40535c2",
  null
  
)

export default component.exports